/**
 * defa.views.AlarmGroupOptionForm
 * The view for deciding yes/no to installing an insurance.
 * @version 1.2.0
 */
import Form     from 'scripts/poppet/form';
import template from 'templates/alarmGroupOptionForm.jst.html';

const AlarmGroupOptionForm = Form.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: template,
	
	
	// ------------------------------------------------
	// Event handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Submits the form.
	 * @void
	 */
	submit: function () {
		let value = this.$el.find( ':checked' ).val();
		this.trigger( value ); // change, clear, or skip.
	},
	
	
} );


export default AlarmGroupOptionForm;